<template>
  <CarouselAdvert></CarouselAdvert>
  <div class="category_title_menu">
    <div style="height: 40px">
      <div
        style="
          text-align: center;
          font-size: 16pt;
          background-color: #fff;
          height: 40px;
          line-height: 40px;
        "
      >
        {{ CollectionOpt.Name }}
      </div>
    </div>

    <div>
      <div
        v-for="(item, index) in CollectionOpt.CategorySimpleModel"
        :key="index"
      >
        <p>
          {{ item.Name }}
        </p>

        <div v-for="(product, indexs) in item.Products" :key="indexs">
          <div class="ProductItems">
            <div
              style="
                display: flex;
                width: 100%;
                min-height: 70px;
                border-bottom: 1px solid #eee;
              "
            >
              <div style="position: relative">
                <van-image
                  class="item_picture"
                  fit="contain"
                  :src="product.CompleteImages"
                  style="border-radius: 10px; margin: 5px; height: 70px"
                >
                </van-image>

                <div
                  style="
                    position: absolute;
                    top: 1px;
                    left: 4px;
                    font-size: 18pt;
                    color: red;
                  "
                >
                  {{ product.Price }}
                </div>
              </div>

              <div style="flex-grow: 1; text-align: center">
                <div style="flex-grow: 1; padding: 5px">
                  <div
                    style="
                      margin: 3px;
                      text-align: left;
                      color: red;
                      font-size: 11pt;
                    "
                  >
                    {{ product.Name }}
                  </div>
                  <div style="margin: 3px">
                    <van-checkbox
                      v-model="product.IsCheckd"
                      @change="AddShoppingCart()"
                      >{{
                        tools.GetLanguageValue("public.app.选择")
                      }}</van-checkbox
                    >
                  </div>

                  <div style="margin: 3px">
                    <van-checkbox v-model="product.IsPrecedence"
                      >{{ tools.GetLanguageValue("public.app.先出") }}
                    </van-checkbox>
                  </div>

                  <input
                    style="
                      width: calc(100% - 1px);
                      border: 0px;
                      border-bottom: 2px solid #eee;
                      font-size: 9pt;
                    "
                    v-model="product.Remarks"
                    :placeholder="
                      tools.GetLanguageValue('public.app.请输入备注')
                    "
                  />
                </div>

                <!-- <div>
                  {{ product.Name }}
                </div> -->
              </div>
            </div>
            <div
              v-if="product.IsCheckd && product.IsRemarkRequired"
              style="width: 100%; min-height: 60px; display: flex; padding: 3px"
            >
              <div v-if="product.IsRemarkRequired">
                <van-checkbox-group
                  v-model="product.ProductRemarkOpts"
                  direction="horizontal"
                  :max="product.RemarkRequiredCount"
                >
                  <div
                    v-for="(item, index) in product.ProductRemark"
                    :key="index"
                    class="product_remark"
                  >
                    <van-checkbox
                      @click="CheckProductRemark"
                      :icon-size="17"
                      shape="square"
                      :name="item"
                    >
                      {{ item.Name }}
                      <span v-if="item.Price > 0">
                        {{ item.PriceFormat }}
                      </span>
                    </van-checkbox>
                  </div>
                </van-checkbox-group>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 
      <van-tabs v-model:active="active" @change="beforeChange" color="#3ca7f0" scrollspy sticky style="width: 100%;">
        <van-tab class="category_title_tab" v-for="(item, index) in CollectionOpt.CategorySimpleModel" :key="index">
          <template #title> {{ item.Name }} </template>
          <div class="category_content_itemtitle">
            {{ item.Name }}
          </div>
          <div style="height: 600px" v-if="item.Products.length == 0">
            <van-empty :description="tools.GetLanguageValue('public.app.正在加载')" />
          </div>
          <div class="product_content" v-for="(product, indexs) in item.Products" :key="indexs">
 
            <div class="product_item" v-if="product != null">
              <StoreProductCollection :ImageHeigth="ProductImageHeigth" :update="UpdateProducts" :ProductItem="product"
                :CollectionId="CollectionId" :OrderId="OrderId" :CartId="CartId" />
  
            </div>
          </div>
        </van-tab>
      </van-tabs> -->
    <p style="text-align: center">Powered by Jiecheng</p>
    <br />
    <br />
    <br />
    <br />
    <br />
  </div>
 
  <div class="bottom_tabbar" v-if="!VerificationSecurityCodeWindow">
    <div
      class="bottom_tabbar_cart"
      @click="Skip('storeshoppingcart')"
      v-if="!VerificationSecurityCodeWindow"
    >
      <van-icon name="shopping-cart-o" color="#fff" :size="33" />
    </div>

    <div class="payment_amount" @click="Skip('storeshoppingcart')">
      {{ tools.GetLanguageValue("public.app.购物车") }}
    </div>
    <div class="confirm_payment" @click="AddStoreRecommendCollectionDetail">
      {{ tools.GetLanguageValue("public.app.添加") }}
    </div>
    <!-- VerificationSecurityCode() -->
  </div>

  <van-floating-bubble
    v-if="!ViewCollectionInfoWindow && AppSystemSettings.IsTaocanInfo"
    @click="
      () => {
        ViewCollectionInfoWindow = true;
        GetViewCollectionInfo();
      }
    "
    v-model:offset="offset"
    axis="xy"
    icon="info-o"
    magnetic="x"
  />

  <van-popup
    id="listCarts"
    v-model:show="StoreRecommendCollectionDetailWindow"
    position="bottom"
    :style="{ height: '100%' }"
    style="z-index: 11111111234123412311"
  >
    <div style="overflow: auto; height: calc(100%); position: relative">
      <div style="height: calc(100% - 10px); overflow: auto">
        <p style="font-size: 18pt">
          {{ tools.GetLanguageValue("public.app.已选列表") }}
        </p>
        <p
          v-if="TempShoppingCartsIsTipsNull"
          style="font-size: 13pt; color: red"
        >
          {{ tools.GetLanguageValue("public.app.您没有选择套餐") }}
        </p>
        <div
          v-for="(item, index) in TempShoppingCarts"
          :key="index"
          style="min-height: 70px; border: 1px solid #eee; padding: 5px"
        >
          <div
            v-if="item.ProductType == 600"
            style="
              min-height: 70px;
              display: flex;
              gap: 8px;
              margin: 5px;
              position: relative;
            "
          >
            <div
              style="
                position: absolute;
                top: 1px;
                right: 1px;
                color: red;
                font-size: 18pt;
              "
            >
              {{ item.Total }}
            </div>
            <div style="flex-grow: 1; position: relative">
              <div style="width: calc(100% - 80px)">{{ item.Name }}</div>
            </div>
          </div>

          <div
            v-if="item.ProductType != 600"
            style="
              min-height: 70px;

              display: flex;
              gap: 8px;
              margin: 5px;
              position: relative;
            "
          >
            <van-image
              :style="{ height: imageHeigth + 'px' }"
              class="item_picture"
              fit="contain"
              :src="item.Images"
            />
            <div
              style="
                position: absolute;
                top: 1px;
                right: 1px;
                color: red;
                font-size: 18pt;
              "
            >
              {{ item.Total }}
            </div>
            <div style="width: 140px; position: relative">
              <div style="width: 100%">{{ item.Name }}</div>
              <div
                v-if="item.ProductType != 600"
                style="
                  width: 100%;
                  margin-top: 4px;
                  font-size: 9pt;
                  color: #111;
                  display: flex;
                  justify-content: space-between;
                  position: absolute;
                  bottom: 1px;
                "
              >
                <input
                  v-model="item.Remarks"
                  :placeholder="tools.GetLanguageValue('public.app.请输入备注')"
                  style="border: 0px; border-bottom: 1px solid #eee"
                />
                <van-icon name="edit" font="10" />
              </div>
            </div>
          </div>
          <div style="display: flex; width: 100%">
            <div
              v-for="itemx in item.ProductRemarkItemsOpt"
              :key="itemx.Id"
              style="
                background-color: chocolate;
                font-size: 11pt;
                border-radius: 3px;
                margin: 3px;
                padding: 3px;
                color: #fff;
              "
            >
              {{ itemx.Name }}
            </div>
          </div>
          <!-- ProductRemarkOpts -->
        </div>
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
      </div>

      <div
        style="
          width: 100%;
          margin: 0 auto;
          margin-top: 10px;
          position: absolute;
          margin-top: 10px;
          position: absolute;
          bottom: 1px;
          background-color: #fff;
        "
      >
        <div style="width: 100%; text-align: center">
          <input
            v-model="TempCartStoreRecommendCollectionDetail.Remarks"
            style="
              width: calc(100% - 30px);
              margin: 0 auto;
              height: 30px;
              border: 0px;
              border-bottom: 1px solid #eee;
            "
            :placeholder="tools.GetLanguageValue('public.app.请输入您的名称')"
          />
        </div>
        <div
          style="
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin: 0 auto;
            margin-top: 10px;
            margin-bottom: 5px;
            width: calc(100% - 30px);
          "
        >
          <van-button
            type="primary"
            size="small"
            @click="StoreRecommendCollectionDetailWindow = false"
            style="width: 120px"
          >
            {{ tools.GetLanguageValue("public.app.关闭") }}</van-button
          >

          <van-button
            type="primary"
            size="small"
            @click="AutoAddCollectionItemBatchsConfirm"
            style="width: 120px"
          >
            {{ tools.GetLanguageValue("public.app.添加") }}</van-button
          >
        </div>
      </div>
    </div>
  </van-popup>
</template>
<script>
import axios from "../../commons/AxiosMethod.js";
import StoreProductCollection from "../../components/Stores/StoreProductCollection.vue";
import StoreShoppingCartTabbar from "../../components/tabbars/StoreShoppingCartTabbar.vue";
import { showToast, showConfirmDialog } from "vant";
import tools from "../../commons/tools.js";
import CarouselAdvert from "../../components/CarouselAdvert.vue";
import { Collapse, CollapseItem, Tab, Tabs } from "vant";
export default {
  data() {
    return {
      index: 0,
      offset: { x: document.body.clientWidth - 50, y: 200 },
      clientWidth: document.body.clientWidth,
      clientHeight: document.documentElement.clientHeight,

      ViewCollectionInfo: [],
      active: "",
      tools: tools,
      CollectionOpt: {}, // 当前合集
      CollectionPriceInfo: null,

      CollectionId: "", // 合集ID
      OrderId: "", // 订单ID
      CartId: "", // 购物车ID
      Carts: {},
      AppSystemSettings: {
        IsTaocanInfo: false,
      },

      ProductImageHeigth: 100,
      StoreRecommendCollectionDetailWindow: false,

      //临时购物车
      TempCartStoreRecommendCollectionDetail: {
        CollectionId: "",
        ProductItems: [],
        Remarks: "",
      },
      TempShoppingCarts: [],
      TempShoppingCartsIsTipsNull: false, //是否提示没有选择套餐

      AddCartLockd: false, //添加锁
    };
  },
  name: "App",
  mounted() {
    this.CollectionId = this.$route.query.collectionId;
    this.OrderId = this.$route.query.orderId;
    this.CartId = this.$route.query.cartId;
    this.TableId = localStorage.getItem("Cache-TableId");

    this.ProductImageHeigth = localStorage.getItem("ProductImageHeigth");

    this.GetCollections([]);

    try {
      // IsTaocanInfo
      this.AppSystemSettings = JSON.parse(
        localStorage.getItem("AppSystemSettings")
      );
    } catch (e) {}
  },
  components: {
    StoreProductCollection,
    StoreShoppingCartTabbar,
    CarouselAdvert,
  },
  methods: {
    AddShoppingCart(item) {
      this.ProductCheckd = [];

      this.CollectionOpt.CategorySimpleModel.forEach((element) => {
        element.Products.forEach((product) => {
          if (product.IsCheckd == true) {
            this.ProductCheckd.push({
              ProductId: product.Id,
              IsPrecedence: product.IsPrecedence,
              Remarks: product.Remarks,
              ProductRemarkOpts: product.ProductRemarkOpts,
            });
          }
        });
      });
      this.TempCartStoreRecommendCollectionDetail.TableId = this.TableId;
      this.TempCartStoreRecommendCollectionDetail.ProductItems =
        this.ProductCheckd;
      this.TempCartStoreRecommendCollectionDetail.CollectionId =
        this.CollectionOpt.Id;

      this.GetRecommendCollectionPriceById(
        this.TempCartStoreRecommendCollectionDetail
      );
    },

    //添加时的确认框
    AutoAddCollectionItemBatchsConfirm() {
      showConfirmDialog({
        teleport: "#listCarts",
        title: tools.GetLanguageValue("点击确定添加") ,

        confirmButtonText: tools.GetLanguageValue("public.app.确认"),
        cancelButtonText: tools.GetLanguageValue("public.app.取消"),
      })
        .then(() => {
          this.AutoAddCollectionItemBatchs();
        })
        .catch(() => {});
    },

    //添加
    AutoAddCollectionItemBatchs() {
      //可能需要枷锁
      // if (this.AddCartLockd) {
      //   return;
      // }

      try {
        this.AddCartLockd = true;
        axios.apiMethod(
          "/Store/StoreOrder/AutoAddCollectionItemBatchs",
          "post",
          this.TempCartStoreRecommendCollectionDetail,
          (result) => {
            this.AddCartLockd = false;
            if (result.Data.IsSuccess) {
              this.StoreRecommendCollectionDetailWindow = false;
              this.GetCollections([]);
            } else {
              showConfirmDialog({
                teleport: "#listCarts",
                title: result.Data.Msg,

                confirmButtonText: tools.GetLanguageValue("public.app.确认"),
                cancelButtonText: tools.GetLanguageValue("public.app.取消"),
              })
                .then(() => {
                  this.GetProduct();
                })
                .catch(() => {
                  // on cancel
                });
            }
          }
        );
      } catch (e) {
        this.AddCartLockd = false;
      }
    },
    Skip(item) {
      var TableId = localStorage.getItem("Cache-TableId");
      this.$router.push({
        path: item,
        query: {
          tableId: TableId,
        },
      });
    },
    //添加推荐套餐详细
    AddStoreRecommendCollectionDetail() {
      this.ProductCheckd = [];

      this.CollectionOpt.CategorySimpleModel.forEach((element) => {
        element.Products.forEach((product) => {
          if (product.IsCheckd) {
            this.ProductCheckd.push({
              ProductId: product.Id,
              IsPrecedence: product.IsPrecedence,
              Remarks: product.Remarks,
              ProductRemarkOpts: product.ProductRemarkOpts,
            });
          }
        });
      });
      this.TempCartStoreRecommendCollectionDetail.TableId = this.TableId;
      this.TempCartStoreRecommendCollectionDetail.ProductItems =
        this.ProductCheckd;
      this.TempCartStoreRecommendCollectionDetail.CollectionId =
        this.CollectionOpt.Id;

      axios.apiMethod(
        "/shops/ResaleShoppings/CalculateStoreRecommendCollectionDetail",
        "post",
        this.TempCartStoreRecommendCollectionDetail,
        (result) => {
          this.TempShoppingCarts = result.Data.TempCarts;
          this.TempShoppingCartsIsTipsNull = result.Data.IsTips;

          this.StoreRecommendCollectionDetailWindow = true;
        }
      );
    },
    //查看套餐信息
    GetViewCollectionInfo() {
      axios.apiMethod(
        "/Store/StoreOrder/ViewCollectionInfo",
        "get",
        { tableId: this.TableId },
        (result) => {
          this.ViewCollectionInfo = result.Data;
          this.TimerResidue = setInterval(() => {
            this.ViewCollectionInfo.ResidueTime--; // 每隔1秒自增计数器值
            if (this.ViewCollectionInfo.ResidueTime <= 0) {
              this.ViewCollectionInfo.ResidueTime = 0;
              clearInterval(this.TimerResidue);
            }
          }, 1000); // 设置间隔为1秒
        }
      );
    },

    UpdateProducts() {},

    // 获取合集
    GetRecommendCollectionPriceById(params) {
      axios.apiMethod(
        "/shoppings/Collection/GetRecommendCollectionPriceById",
        "post",
        params,
        (result) => {
          var priceInfos = result.Data;

          this.CollectionOpt.CategorySimpleModel.forEach((element) => {
            element.Products.forEach((product) => {
              priceInfos.forEach((price) => {
                if (price.Id == product.Id) {
                  product.Price = price.Price;
                }
              });
            });
          });
        }
      );
    },

    // 获取合集
    GetCollections(tempCarts) {
      axios.apiMethod(
        "/shoppings/Collection/GetRecommendCollectionById",
        "post",
        {
          collectionId: this.CollectionId,
          tableId: this.TableId,
          TempCarts: tempCarts,
        },
        (result) => {
          this.CollectionOpt = result.Data;

          //   for (
          //     var i = 0;
          //     i < this.CollectionOpt.CategorySimpleModel.length;
          //     i++
          //   ) {
          //     if (i < 3) {
          //       this.GetCollectionCategoryProduct(
          //         this.CollectionOpt.CategorySimpleModel[i]
          //       );
          //     }
          //   }

          this.TempCartStoreRecommendCollectionDetail.TableId = this.TableId;
          this.TempCartStoreRecommendCollectionDetail.ProductItems = [];
          this.TempCartStoreRecommendCollectionDetail.CollectionId =
            this.CollectionOpt.Id;

          this.GetRecommendCollectionPriceById(
            this.TempCartStoreRecommendCollectionDetail
          );
        }
      );
    },

    // 获取分类下的商品
    GetCollectionCategoryProduct(category) {
      if (category.Products.length == 0) {
        axios.apiMethod(
          "/shoppings/Collection/GetCollectionCategoryProduct",
          "get",
          {
            categoryId: category.Id,
            collectionId: this.$route.query.collectionId,
          },
          (result) => {
            try {
              category.Products = result.Data;
            } catch (e) {}
          }
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ProductItems {
  width: calc(100% - 10px);
  min-height: 80px;
  border: 1px solid #fff;
  background-color: #fff;
  margin: 0 auto;
  margin-top: 5px;
  border-radius: 8px;
}

.bottom_tabbar {
  background-color: #333;

  position: fixed;
  bottom: 0px;
  width: 100%;
  height: 50px;
  border-top: 1px solid #eee;
  opacity: 0.9;
  display: flex;
  justify-items: flex-end;
  justify-content: flex-end;
  color: aliceblue;

  .payment_amount {
    width: calc(100% - 150px - 85px);
    text-align: center;
    line-height: 50px;
    color: aliceblue;
  }
}
.bottom_tabbar_cart {
  position: fixed;

  bottom: 10px;
  left: 5px;
  height: 80px;
  width: 80px;
  background-color: rgb(0, 157, 255);
  border-radius: 40px;

  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.category_content_itemtitle {
  font-size: 12pt;
  font-weight: 700;
  font-size: 14pt;
  padding: 10px;
  background-color: #eee;
}

.search_content {
  height: 70px;
  display: flex;

  .search {
    width: 100%;
  }
}

.category_title_menu {
  width: 100%;
  top: 0px;
  z-index: 9090000;
  background-color: #eee;
  overflow: auto;
}

.category_title_tab {
  background-color: #eee;
}

.product_content {
  margin: 0 auto;
  padding: 5px !important;

  background-color: #eee;

  .product_item {
    margin: 0 auto;
    width: calc(100% - 5px);
  }
}

.ViewCollectionInfo {
  position: fixed;
  z-index: 65816516516;
  top: 50px;
  right: 0px;
  width: 260px;
  background-color: #01a1ff;
  padding: 10px;
}

.confirm_payment {
  width: 150px;
  height: 60px;
  text-align: center;
  line-height: 50px;
  border-left: 1px solid 409eff;
  background-color: rgb(0, 157, 255);
}

//下单
.confirm_placeOrder {
  width: 100%;
  height: 60px;
  text-align: center;
  line-height: 50px;
  border-left: 1px solid 409eff;
  background-color: rgb(0, 157, 255);
  color: #eee;
  position: absolute;
  bottom: 0px;
}

.item_picture {
  background-color: #fff;
  width: 120px;
  position: relative;
}
.product_remark {
  padding: 5px;
  font-size: 9pt;
  border: 1px solid #eee;
  margin: 3px;
  border-radius: 5px;
}
</style>
